<template>
  <div class="w-100 orcamento-info-adicional" id="orcamento-info-adicional">
    <span class="orcamento-info-adicional-icon">i</span>
    <span>
      Para enviar o pedido, o valor mínimo deve ser de R$ 600,00,
      considerando a Quantidade, o Valor unitário dos produtos e a
      Margem.
    </span>
  </div>
</template>

<script>
export default {
  name: "OrcamentoInformacaoAdicional",
};
</script>

<style scoped>
.orcamento-info-adicional {
  align-items: center;
  color: #0075EB;
  display: flex;
  font-weight: 400;
  gap: 10px;
}

.orcamento-info-adicional-icon {
  align-items: center;
  background-color: #0075EB;
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  flex: 0 0 24px;
  font-size: 14px;
  font-weight: 700;
  height: 24px;
  justify-content: center;
  line-height: 1;
  text-transform: uppercase;
  width: 24px;
}
</style>
